import React from 'react'

const IntroductionContent = ({ message, onClick, addClass="" }) => {
  return (
    <div className={`introduction-content ${addClass}`} dangerouslySetInnerHTML={{ __html: message }} onClick={onClick}></div>
  );
};

export default IntroductionContent